import { render } from "./ClubsPage.vue?vue&type=template&id=55958681&scoped=true"
import script from "./ClubsPage.vue?vue&type=script&lang=js"
export * from "./ClubsPage.vue?vue&type=script&lang=js"

import "./ClubsPage.vue?vue&type=style&index=0&id=55958681&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55958681"]])

export default __exports__